export const EMAIL_OF_INTERNAL_TESTER = "bvt@bvarta.com";
